import { render, staticRenderFns } from "./checkQI.vue?vue&type=template&id=62218bf4&scoped=true&"
import script from "./checkQI.vue?vue&type=script&lang=js&"
export * from "./checkQI.vue?vue&type=script&lang=js&"
import style0 from "./checkQI.vue?vue&type=style&index=0&id=62218bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62218bf4",
  null
  
)

export default component.exports